import React from 'react';
import PropTypes from 'prop-types';
import NriJournalistBanner from 'components/NriJournalistBanner';
import CricketScoreCardLoader from 'components_v2/common/CricketScoreCard/CricketScoreCardLoader';
import Link from 'components/Link';
// import TimesTop10Loader from 'components/TimesTop10/TimesTop10Loader';
import Banner from 'components/Banner';
import IFrameWdt from 'components_v2/common/IFrameWdt';
import CardList from 'components_v2/common/CardListV2';
import PollWidget from 'components_v2/common/PollWidget';
import WithMiniTv from 'modules/WithMiniTv/WithMiniTv';
import WithIframeWdt from 'components_v2/common/IFrameWdt/WithIframeWdt';
import SunSignsWidget from 'components_v2/common/SunSignsWidget/SunSignsWidget';
import { WEB_INDIA_HP_GA_CAT } from 'constants/index';
import CTAWithImage from 'components_v2/desktop/CTA_with_image';
import InViewObserver from 'components/InViewObserver';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import TOIPlusWidget from 'components_v3/desktop/TOIPlusWidget/TOIPlusWidget';
import SingleCardSlider from '../SingleCardSlider';
import Listingheader from '../../common/ListingheaderV2';
import RenderAds from '../RenderAds';
import Accordion from '../AccordionV2/Accordion';
import PhotoWidget from '../../../components/desktop/EtimesPhotosWidget';
import Market from '../../../../newslisting/components/common/MarketSnapshot';
import LoadableComponentLoader from '../../../../../components_v2/common/LoadableComponentLoader/LoadableComponentLoader';

import s from '../../../Home.scss';
import IPLWidget from '../../../../../components_v2/mobile/IPLWidget/IPLWidget';
import ErrorBoundary from '../../../../../components/ErrorBoundary/ErrorBoundary';
import TOIAssistHPWidget from '../TOIAssistHPWidget/TOIAssistHPWidget';
import CalculatorList from '../../../../calculator/components/mobile/CalculatorList/CalculatorList';
import ToiPlusPlanPageCta from '../../../../../components_v2/common/ToiPlusPlanPageCta/ToiPlusPlanPageCta';
import InterSectionBorder from '../../../../../components_v2/common/InterSectionBorder/InterSectionBorder';
import GamesCard from '../../common/GamesCard/GamesCard';

class RenderInserts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fallbacks: {},
      showFallbackComponent: false,
    };
  }

  setFallback = (tn, index, enableFallback) => {
    this.setState({
      fallbacks: {
        ...this.state.fallbacks,
        [`${tn}_${index}`]: enableFallback,
      },
    });
  };

  enableFallbackComponent = () => {
    this.setState({ showFallbackComponent: true });
  };

  render() {
    const { data, newga, ga4Type, ga4Category, isInPageDock } = this.props;
    if (data && data instanceof Array) {
      return data.map((item, index) => {
        if (
          item.fallback &&
          ((!item.clientSide && !item.data) ||
            this.state.fallbacks[`${item.tn}_${index}`])
        ) {
          // eslint-disable-next-line no-param-reassign
          item = item.fallback;
        }

        if (
          (item.type === 'fallback' && !this.state.showFallbackComponent) ||
          (item.type !== 'fallback' && this.state.showFallbackComponent)
        ) {
          return null;
        }

        if (
          isInPageDock &&
          item?.slotId?.includes &&
          item.slotId.includes('_switchminitv')
        ) {
          return null;
        }

        if (item.tn === 'TOIPlusWidget') {
          if (
            item &&
            item.insert &&
            item.insert.tn &&
            item.insert.tn === 'TOIAssist' &&
            Array.isArray(item.insert.items) &&
            item.insert.items.length >= 3
          ) {
            if (!this.props.toiAssistWidgetDecided) {
              return <div className="rhs_skltn" />;
            }
            return this.props.showToiAssistWidget ? (
              <TOIAssistHPWidget
                data={item.insert}
                isPrime={this.props.isPrime}
              />
            ) : (
              <TOIPlusWidget
                item={item}
                isPrime={this.props.isPrime}
                isUShomepage={this.props.isUShomepage}
              />
            );
          }
          return (
            <TOIPlusWidget
              item={item}
              isPrime={this.props.isPrime}
              isUShomepage={this.props.isUShomepage}
            />
          );
        }

        switch (item.tn) {
          case 'minitv':
            return (
              isInPageDock && <WithMiniTv isWapView={false} isInPageDock />
            );
          case 'sunsign_widget':
            return (
              <div>
                <SunSignsWidget
                  items={item.items}
                  isRHSWidget
                  isRHSWidgetMobile
                />
              </div>
            );
          case 'iframe':
            return WithIframeWdt(IFrameWdt, {
              ...item,
              key: item.tn,
              lazy: true,
            });
          case 'banner': {
            return (
              <Banner
                imageUrl={item.image && item.image.src ? item.image.src : ''}
                link={item.link}
                gaData={item.ga}
                altTag=""
                target={item.target || ''}
                wrapperClassName={s[item.wrapperclass || 'maskindiabanner']}
                ga4Type={ga4Type}
                ga4Category={ga4Category}
              />
            );
          }
          case 'goldSilver': {
            return <Market data={item} />;
          }
          case 'NriJournalistBanner':
            return (
              <NriJournalistBanner
                data={item}
                newga={this.props.newga}
                key={item.tn}
              />
            );
          // case 'timestopten':
          //   return (
          //     <TimesTop10Loader
          //       inUshome
          //       setFallback={enableFallback => {
          //         this.setFallback(item.tn, index, enableFallback);
          //       }}
          //     />
          //   );
          // case 'TOIPlusWidget':
          //   return <TOIPlusWidget item={item} />;
          case 'list':
            return (
              <div className={`${'grid_wrapper'}`} key={`${item.tn}_${index}`}>
                <CardList
                  data={item.data || item.items}
                  nonFeaturedItemWrapperClass={`${'col_l_6'} ${'col_m_6'}`}
                  newga="SportsSection_Actions#SportsClick-"
                  imgWidth="200"
                  ga4Type={ga4Type}
                  ga4Category={ga4Category}
                  gaIndex={index + 1}
                />
              </div>
            );
          case 'calculator': {
            return (
              <div className="col_l_12 col_m_6">
                {item && (
                  <CalculatorList
                    items={item.data || item.items}
                    name={item.name}
                    hl={item.hl}
                    isWapView={false}
                    ga4Type={item.ga4Type || ''}
                    ga4Category={item.ga4Category || ''}
                  />
                )}
              </div>
            );
          }
          case 'poll':
            return (
              <PollWidget
                {...item}
                hideShareFeature
                key={`${item.tn}_${index}`}
                isLoggedIn={this.props.isLoggedIn}
                toggleLoginBox={this.props.toggleLoginBox}
                fallback={this.enableFallbackComponent}
                // ga4Type={ga4Type}
                ga4Type="poll_widget"
                ga4Category={ga4Category}
              />
            );
          case 'fake_news':
            return (
              <ErrorBoundary>
                <div className={s.fakenews_wrapper}>
                  <LoadableComponentLoader
                    loadInView
                    loadableComponentName="FakeNews"
                    data={item}
                  />
                </div>
              </ErrorBoundary>
            );
          case 'column_1_list':
            return (
              <div
                className={`${'grid_wrapper'} ${'grid_wrapper_heading'}`}
                key={`${item.tn}_${index}`}
              >
                {item.name || item.link ? (
                  <Listingheader
                    headingname={item.name}
                    headingLink={item.link || item.path}
                    size="small"
                    newga={`${item.name}Section_Actions#${
                      item.name
                    }_HeadingClick`}
                    target={item.target}
                    ga4Type={ga4Type}
                    ga4Category={ga4Category}
                  />
                ) : null}
                <CardList
                  data={item.items}
                  nonFeaturedItemWrapperClass={`${s.paddingBottom24} ${
                    s.paddingTop12
                  } noBorder ${'col_l_12'} ${'col_m_12'}`}
                  nonFeaturedListTileType="defaultTile"
                  isInlineSmallIconCard={this.props.isInlineSmallIconCard}
                  newga={newga}
                  imgWidth="100"
                  showDuration={false}
                  showPhotosCount={false}
                  ga4Type={ga4Type}
                  ga4Category={ga4Category}
                  gaIndex={index + 1}
                />
              </div>
            );
          case 'row_1_news_list':
            return (
              <div className="row-news-list">
                {item &&
                  item.items &&
                  item.items.map(row => (
                    <Link
                      key={row.id}
                      to={row.wu}
                      className="linktype1"
                      //data-newga={`TopSection-Actions#TopClick-Grid3/${index}/${item.wu}`}
                    >
                      <span>{row.hl}</span>
                      {row.type === 'photostory' ? (
                        <i className="icon photos" />
                      ) : null}
                      {row.type === 'video' ? (
                        <i className="icon videos" />
                      ) : null}
                    </Link>
                  ))}
              </div>
            );
          case 'col_1_news_list':
            return (
              <div className={this.props.col1NewsListClass}>
                <CardList
                  data={item.items}
                  showDescription
                  nonFeaturedItemWrapperClass="col_l_6 col_m_6 bdr_right no_bdr_last"
                  itemClass="linktype2"
                  nonFeaturedListWrapperClass="grid_wrapper"
                  newga={
                    item.name
                      ? `${item.name}Section_Actions#$typeClick-`
                      : `${newga}$typeClick-`
                  }
                  htmlKeys={item.htmlKeys}
                  key={`${item.id}_${item.tn}`}
                  ga4Type={ga4Type}
                  ga4Category={ga4Category}
                  gaIndex={index + 1}
                />
              </div>
            );
          case 'accordion':
            return (
              <div key={item.tn}>
                {item.border && item.border === 'top' && <InterSectionBorder />}
                <Listingheader
                  headingname={item.name}
                  headingLink={item.link || item.path}
                  size={item.cardSliderCount ? 'default' : 'small'}
                  newga={`${this.props.newga}/${item.name}_HeadingClick`}
                  target={item.target}
                  ga4Type={ga4Type}
                  ga4Category={ga4Category}
                />
                <Accordion
                  data={item.items}
                  newga={
                    this.props.newga
                      ? this.props.newga
                      : `click-${item.name}-${this.props.newga}`
                  }
                  slideFlag={item.slideFlag ? item.slideFlag : 1}
                  cardSlider={item.cardSlider}
                  isPrime={this.props.isPrime}
                  ga4Type={ga4Type}
                  ga4Category={ga4Category}
                  cardSliderCount={item.cardSliderCount}
                />
              </div>
            );
          case 'etimesphotos':
            return (
              <div key={item.tn}>
                <Listingheader
                  headingname={item.name}
                  headingLink={item.link || item.path}
                  size="small"
                  newga={`${this.props.newga}/${item.name}_HeadingClick`}
                  target={item.target}
                  ga4Type={item?.ga4Type ? item?.ga4Type : ga4Type}
                  ga4Category={
                    item?.ga4Category ? item?.ga4Category : ga4Category
                  }
                />
                <PhotoWidget
                  key={item.tn}
                  data={item}
                  ga4Type={item?.ga4Type ? item?.ga4Type : ga4Type}
                  ga4Category={
                    item?.ga4Category ? item?.ga4Category : ga4Category
                  }
                />
              </div>
            );
          case 'cricketscorewidget':
            // cricketscorewidget to be handled in another release
            this.setFallback(item.tn, index, true);
            return null;
          case 'slider':
            if (this.props.showToiPlusEntryPoints) {
              return (
                <SingleCardSlider
                  data={item.items}
                  nonFeaturedItemWrapperClass={`${'col_l_4'} ${'col_m_4'}`}
                  // newga="SportsSection_Actions#SportsClick-"
                  imgWidth="200"
                  isPrime={this.props.isPrime}
                />
              );
            } else if (this.props.isPrime && item.itemsEuCa) {
              return (
                <SingleCardSlider
                  data={item.itemsEuCa}
                  nonFeaturedItemWrapperClass={`${'col_l_4'} ${'col_m_4'}`}
                  // newga="SportsSection_Actions#SportsClick-"
                  imgWidth="200"
                  isPrime={this.props.isPrime}
                />
              );
            }
            return null;
          case 'ad':
            return (
              <>
                <RenderAds
                  adObject={item}
                  addMarginTop={this.props.addMarginTop}
                  lazyload={this.props.lazyload}
                  key={`${item.tn}_${index}`}
                  isWapView={false}
                  adWrapperClass={
                    this.props.wrapperjClass || this.props.adWrapperClass
                  }
                  immediateLoad={this.state.showFallbackComponent}
                />
                {item.showRemoveAdButton === 'true' && (
                  <ToiPlusPlanPageCta
                    pageType="homepage"
                    adname={item.adslotName || item.name}
                  />
                )}
              </>
            );
          case 'games_card_widget_Slider':
            return (
              <ErrorBoundary>
                <GamesCard
                  gaCategory={{
                    ga4Type: 'home_widget',
                    ga4Label: 'homepage',
                    ga4Type2: 'main_line_up_concept_8',
                    ga4Category2: 'game_widget_click',
                    ga4Label2: 'rightgrid_',
                  }}
                  widgetUsedOn="homepage"
                  sectionData={item}
                />
              </ErrorBoundary>
            );
          case 'adlist':
            return (
              <div className={s.inlineAdList}>
                {item.ads.map(adItem => (
                  <div className={s.inlineAdItem}>
                    <RenderAds
                      adObject={adItem}
                      addMarginTop={this.props.addMarginTop}
                      lazyload={this.props.lazyload}
                      key={`${item.tn}_${index}`}
                      isWapView={false}
                      adWrapperClass={this.props.adWrapperClass}
                      immediateLoad={this.state.showFallbackComponent}
                    />
                  </div>
                ))}
              </div>
            );
          case 'cricket_score_card':
            return (
              <CricketScoreCardLoader data={item} gaCat={WEB_INDIA_HP_GA_CAT} />
            );
          case 'live_cricket_score_card':
            return (
              <ErrorBoundary>
                <IPLWidget
                  {...item}
                  isLiveScoreWidget
                  autoRefresh
                  isLiveIccIplWpl
                  gaData="Scorecard_widget|click_web|Homepage"
                  gaViewData={['Scorecard_widget', 'view_web', 'Homepage']}
                />
              </ErrorBoundary>
            );
          case 'cta_with_image':
            return (
              <InViewObserver
                inViewCallback={() => {
                  if (item && item.id === 'saffola_banner') {
                    analyticsWrapper('ga4', {
                      event: 'user_shown',
                      type: 'saffola_banner_business',
                    });
                  }
                  if (item && item.id === 'etmoneybusiness') {
                    analyticsWrapper('ga4', {
                      event: 'user_shown',
                      type: 'et_money_banner',
                      category: 'business_listing',
                    });
                  }
                }}
              >
                <CTAWithImage
                  key={item.tn}
                  data={item}
                  gaAction={`${item.name}_Click`}
                  gaLabelPerfix={`${item.name}/click/`}
                />
              </InViewObserver>
            );
          default:
            return null;
        }
      });
    }
    return null;
  }
}

RenderInserts.propTypes = {
  data: PropTypes.shape({}).isRequired,
  addMarginTop: PropTypes.bool,
  lazyload: PropTypes.bool,
  newga: PropTypes.string,
  col1NewsListClass: PropTypes.bool,
  isWapView: PropTypes.bool,
  isPrime: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isInlineSmallIconCard: PropTypes.bool,
  wrapperjClass: PropTypes.string,
  adWrapperClass: PropTypes.shape({}),
  showToiPlusEntryPoints: PropTypes.bool,
  ga4Category: PropTypes.string,
  ga4Type: PropTypes.string,
  isUShomepage: PropTypes.bool,
};

RenderInserts.defaultProps = {
  addMarginTop: false,
  lazyload: false,
  newga: '',
  col1NewsListClass: false,
  isWapView: false,
  isPrime: false,
  isLoggedIn: false,
  isInlineSmallIconCard: false,
  wrapperjClass: undefined,
  adWrapperClass: undefined,
  showToiPlusEntryPoints: false,
  ga4Type: '',
  ga4Category: '',
  isUShomepage: false,
};

export default RenderInserts;
